import {
    ISearch,
    ISearchProfile,
    ISearchProvider,
    HorizAlignment,
    SearchProviderFieldType,
    ISearchProviderField, ISearchRequestSubset
} from "../PA.UIM.Core/PA.UIM.Core.IF.Search"
import {PASearch, ISearchRequest} from "../PA.Core/PASearch";
import {SearchUtils} from "../PA.UIM.Core/SearchUtils";
import {PAEnvironment} from "../PA.Core/PAEnvironment";

var vUI_Plan_Management_Search_Fields: {[id:string]: ISearchProviderField } = {
    WB_PLNMGMT_ID:       {type: SearchProviderFieldType.number, renderOptions: { columnName: 'Plan Management WB Id', columnResourceName: 'colId', alignment: HorizAlignment.Center}, domainOptions: {}},
    PLNMGMT_ID:       {type: SearchProviderFieldType.string, renderOptions: { columnName: 'Plan Management Id', columnResourceName: 'colPlanManagementId', alignment: HorizAlignment.Right}, domainOptions: { maxLength: 50}},
    PLNMGMT_NAME:    {type: SearchProviderFieldType.string, renderOptions: { columnName: 'Name', columnResourceName: 'colName', alignment: HorizAlignment.Left}, domainOptions: { maxLength: 256}},
    CREATED_DTTS: {
        type: SearchProviderFieldType.sapdate,
        renderOptions: {
            columnName: 'Created Date',
            columnResourceName: 'colCreateDt',
            alignment: HorizAlignment.Center,
            dateFormat: "MM-dd-yy"
        },
        domainOptions: {}
    },
    MODIFIED_DTTS: {
        type: SearchProviderFieldType.sapdate,
        renderOptions: {
            columnName: 'Modified Date',
            columnResourceName: 'colModifiedDt',
            alignment: HorizAlignment.Center,
            dateFormat: "MM-dd-yy"
        },
        domainOptions: {}
    }
}

var PlanManagementSearchProviderBasic: ISearchProvider = {

    keyFields: {id:    'WB_PLNMGMT_ID',
                id_ui: 'PLNMGMT_ID',
                name:  'PLNMGMT_NAME'},


    searchProviderFields: vUI_Plan_Management_Search_Fields,

    search(searchOptions: ISearchRequestSubset): Promise<any[]> {
        return new Promise<any[]>((resolve, error) => {

            let findRequest = SearchUtils.makeSearchRequest(searchOptions,
                'vUI_Plan_Management_Search',
                this.searchProviderFields,
                [])

            PASearch.findByRequest(findRequest)
                .then((res: any[]) => {
                    resolve(res)
                })
                .catch((err)=> {
                    error(err)
                })
        })
    }

}


var PlanManagementSearchProfileByName: ISearchProfile = {
    profileId: "default",
    profileName: "Search by Id, Name",
    renderOptions: { ui5ResourceId: "PlanManagementSearchProfileByName" },

    profileFilter: [
        {profileFilterName: 'Id',     searchProviderFieldId: 'PLNMGMT_ID', renderOptions: { }},
        {profileFilterName: 'Name',     searchProviderFieldId: 'PLNMGMT_NAME', renderOptions: { }}
    ],  // ISearchFields
    profileDisplayFields: [
        'PLNMGMT_ID','PLNMGMT_NAME',
        'CREATED_DTTS', 'MODIFIED_DTTS'
    ], //string[];   // Search Provider Field Name (Use to Generate Grid Columns)

    profileSearchProvider: PlanManagementSearchProviderBasic,

    // Do sorting last.. not necessary for phase 1
    profileSortIdDefault: "",    //string;
    profileSorts: [] //ISearchSort[];
}


var PlanManagementSearch: ISearch = {
    searchName: "Find PlanManagement",
    renderOptions: { ui5ResourceId: "PlanManagementSearch"},
    searchProfileIdDefault: "default",
    searchProfiles: [PlanManagementSearchProfileByName]
}
PAEnvironment.registerBusinessObjectSearch("PlanManagementBO", "PlanManagement", PlanManagementSearch, "Plan Management Search")

export {PlanManagementSearch}